import { Col } from "components/primitives";
import { FC } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import styled from "styled-components";

import { Header, OuterContainer } from "../Scheduler/scheduleSetting.styles";
import { CurrentGroupConfigSettingItem } from "./currentGroupSettingItem";
import { SavedGroupConfigurations } from "./types";

interface Props {
  savedGroupConfigurationsData: SavedGroupConfigurations[];
  onSubmit: (newSavedGroupConfigs: SavedGroupConfigurations[]) => void;
  setShowGroupModal: (value: boolean) => void;
  selectedGroupConfigIndex: number | undefined; // Allow number or undefined
  setSelectedGroupConfigIndex: (index: number) => void;
  currentStateGroupConfigData: SavedGroupConfigurations;
  setGroupConfig: React.Dispatch<React.SetStateAction<SavedGroupConfigurations>>;
  setData: (value: any) => void;
  data: SavedGroupConfigurations[];
  settings: any;
}

export const SavedGroupConfigs: FC<Props> = ({
  savedGroupConfigurationsData,
  onSubmit,
  setShowGroupModal,
  selectedGroupConfigIndex,
  setSelectedGroupConfigIndex,
  currentStateGroupConfigData,
  setGroupConfig,
  setData,
  data,
  settings,
}) => {
  const handleSelectedConfigItem = (configId: number) => {
    setSelectedGroupConfigIndex(configId);
    const selectedConfig = savedGroupConfigurationsData.find((config) => config.id === configId);
    if (selectedConfig) {
      setGroupConfig({
        ...selectedConfig,
      });
      setData([selectedConfig]);
    }
    setShowGroupModal(true);
  };

  const handleSelectItem = (configId: number) => {
    setSelectedGroupConfigIndex(configId);
    const selectedConfig = savedGroupConfigurationsData.find((config) => config.id === configId);
    if (selectedConfig) {
      setGroupConfig({
        ...selectedConfig,
      });
      setData([selectedConfig]);
    }
  };

  const handleSelectedConfigItemToDelete = (configId: number) => {
    const newData = savedGroupConfigurationsData.filter((config) => config?.id !== configId);
    onSubmit(newData);
    if (data?.some((config) => config?.id === configId)) {
      setData(undefined); // Replace `setData` with your state updater function
    }
  };
  return (
    <OuterContainer>
      <Header>Edit Group Settings</Header>
      {/* <DndProvider backend={HTML5Backend}> */}
      <GroupConfigContainer>
        {savedGroupConfigurationsData &&
          savedGroupConfigurationsData.map((groupConfigItem, index) => {
            if (groupConfigItem) {
              const handleClick = () => handleSelectedConfigItem(groupConfigItem?.id);
              const handleDelete = () => handleSelectedConfigItemToDelete(groupConfigItem?.id);
              const handleClickOnConfigName = () => handleSelectItem(groupConfigItem?.id);

              return (
                <CurrentGroupConfigSettingItem
                  key={groupConfigItem.id}
                  item={groupConfigItem}
                  onDelete={handleDelete}
                  onClick={handleClick}
                  index={index}
                  dataLength={savedGroupConfigurationsData?.length}
                  handleClickOnConfigName={handleClickOnConfigName}
                  selectedGroupConfigIndex={selectedGroupConfigIndex}
                  settings={settings}
                />
              );
            } else {
              return null;
            }
          })}
      </GroupConfigContainer>
      {/* </DndProvider> */}
    </OuterContainer>
  );
};

export const GroupConfigContainer = styled(Col)`
  gap: 5px;
  max-height: 400px;
  overflow-y: auto;
`;
